import Link, { LinkProps } from "ds/components/Link";
import Typography from "ds/components/Typography";
import { ariaCellInteractionProps } from "ds/components/Table/hooks/useKeyboardNavigation/ariaCellInteractionProps";

export type TableCellLinkProps = LinkProps;

const TableCellLink = ({ children, ...linkProps }: TableCellLinkProps) => {
  return (
    <Link size="small" variant="secondary" {...ariaCellInteractionProps} {...linkProps}>
      <Typography variant="p-body3" tag="span">
        {children}
      </Typography>
    </Link>
  );
};

TableCellLink.displayName = "DS.Table.CellLink";

export default TableCellLink;
